export const CUSTOM_FONT_FAMILY = [
    { title: 'Default', model: 'ck-default', class: 'ck-default' },
    { title: 'Arial', model: 'ck-fm-arial', class: 'ck-fm-arial' },
    { title: 'Courier New', model: 'ck-fm-courier-new', class: 'ck-fm-courier-new' },
    { title: 'Georgia', model: 'ck-fm-georgia', class: 'ck-fm-georgia' },
    { title: 'Lucida Sans Unicode', model: 'ck-fm-lucid-sans-unicode', class: 'ck-fm-lucid-sans-unicode' },
    { title: 'Tahoma', model: 'ck-fm-tahoma', class: 'ck-fm-tahoma' },
    { title: 'Times New Roman', model: 'ck-fm-times-new-roman', class: 'ck-fm-times-new-roman' },
    { title: 'Trebuchet MS', model: 'ck-fm-trebuchet-ms', class: 'ck-fm-trebuchet-ms' },
    { title: 'Verdana', model: 'ck-fm-verdana', class: 'ck-fm-verdana' },
];
